export default __webpack_public_path__ + "static/media/five.37c82dca.jpeg";